<template>
  <div v-if="showForm">
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="column">
        <b-form class="col-xs-12">
          <b-form-text> Propriedade * </b-form-text>

          <b-form-select v-model="form.PROPERTY" size="sm">
            <optgroup
              v-for="(optGroup, index) in reportsPropertiesOptions"
              :key="index"
              :label="optGroup.label"
            >
              <option
                v-for="(option, index) in optGroup.options.filter(
                  (opt) => !opt.hide,
                )"
                :key="index"
                :value="option.value"
                :disabled="option.disabled"
              >
                {{ option.text }}
                {{ `${option.disabled ? `(${option.disabled_text})` : ""}` }}
              </option>
            </optgroup>
          </b-form-select>

          <!-- <b-form-select
            v-model="form.PROPERTY"
            size="sm"
          >
            <optgroup label="Válvulas e Bombas">
              <option :value="{ type: 'volume', equipment: 'actuator' }">
                Volume diário
              </option>
              <option :value="{ type: 'flow', equipment: 'actuator' }">
                Vazão
              </option>
              <option :value="{ type: 'open', equipment: 'actuator' }">
                Aberturas
              </option>
              <option :value="{ type: 'modo', equipment: 'actuator' }">
                Modo Manual
              </option>
              <option
                :value="{
                  type: 'actuators_base_report',
                  IS_DAILY: true,
                  equipment: 'actuator',
                  TITLE_REPORT: 'Relatórios de atuadores',
                  TO_PICK_COLUMNS: [
                  'Tempo Acionada',
                  'Vazão Média',
                  'Vazão Média Efetiva',
                  'Volume',
                  ]
                }"
              >
                Relatórios de atuadores
              </option>
            </optgroup>

            <optgroup label="Manejo" v-if="managementAccess">
              <option
                :value="{
                  type: 'daily',
                  group: 'management',
                  equipmentless: true,
                  IS_DAILY: true
                }"
              >
                Relatório Diário de Setores
              </option>
            </optgroup>

            <optgroup label="Estação" v-if="showImprovedReports">
              <option :value="{ type: 'station-reads', group: 'station', equipmentless: true }">
                Relatório De Leituras
              </option>
            </optgroup>

            <optgroup label="Sensores">
              <option :value="{ type: 'measure', equipment: 'sensor' }">
                Medição
              </option>
              <option :value="{ type: 'measure-daily', equipment: 'sensor', IS_DAILY: true }" v-if="managementAccess">
                Média Diária
              </option>
              <option :value="{ type: 'measure-hourly', equipment: 'sensor' }" v-if="managementAccess">
                Média Horária
              </option>
            </optgroup>

            <optgroup label="DIRs">
              <option :value="{ type: 'battery', equipment: 'device' }">
                Bateria
              </option>
              <option :value="{ type: 'stat', equipment: 'device' }">
                Status
              </option>
            </optgroup>
          </b-form-select> -->

          <div v-if="showOptionsReadType">
            <b-form-text id="itemEndDateInputLiveHelp">
              Formato de leitura *
            </b-form-text>
            <b-form-select
              v-model="form.readTime"
              size="sm"
              :state="!!form.readTime"
            >
              <option
                v-for="(readTime, index) in readSpaceOptions"
                :key="index"
                :value="readTime.seconds"
              >
                {{ readTime.text }}
              </option>
            </b-form-select>
          </div>

          <div v-if="form.PROPERTY.type == 'daily'">
            <b-form-text> Dia </b-form-text>
            <b-form-input
              v-model="form.START_DATE"
              type="date"
              size="sm"
              :max="today"
              :state="form.START_DATE != '' ? true : false"
            >
            </b-form-input>
          </div>

          <div v-if="form.PROPERTY.type != 'daily'">
            <b-form-text id="itemStartDateInputLiveHelp"> De * </b-form-text>
            <b-form-input
              v-model="form.START_DATE"
              aria-describedby="itemStartDateInputLiveHelp"
              type="date"
              size="sm"
              :state="form.START_DATE != '' ? true : false"
            >
            </b-form-input>
            <b-form-input
              v-if="!form.PROPERTY.IS_DAILY"
              v-model="form.START_TIME"
              aria-describedby="itemStartDateInputLiveHelp itemStartTimeInputLiveFeedback"
              type="time"
              size="sm"
              :state="form.START_TIME != '' ? true : false"
            >
            </b-form-input>

            <b-form-text id="itemEndDateInputLiveHelp"> Até * </b-form-text>
            <b-form-input
              v-model="form.END_DATE"
              aria-describedby="itemEndDateInputLiveHelp"
              type="date"
              size="sm"
              :state="form.END_DATE != '' ? true : false"
            >
            </b-form-input>

            <b-form-input
              v-if="!form.PROPERTY.IS_DAILY"
              v-model="form.END_TIME"
              aria-describedby="itemEndDateInputLiveHelp itemEndTimeInputLiveFeedback"
              type="time"
              size="sm"
              :state="form.END_TIME != '' ? true : false"
            >
            </b-form-input>
          </div>
          <p />

          <b-form-group v-if="form.PROPERTY.TO_PICK_COLUMNS" label="Medições:">
            <b-form-checkbox-group
              id="checkbox-group-1"
              v-model="form.PICKED_COLUMNS"
              :options="columnsToPickOptions"
              name="flavour-1"
            ></b-form-checkbox-group>
          </b-form-group>
        </b-form>
        <div
          class="col-xs-12"
          v-if="form.PROPERTY.group && form.PROPERTY.group != 'station'"
        >
          <b-btn
            block
            size="sm"
            rounded
            @click="openUsers"
            variant="secondary"
            :disabled="!form.PROPERTY.group"
            >Adicionar ou remover usuários ({{ selected.length }})
          </b-btn>

          <div class="selected-box">
            <div
              class="selected-item"
              v-for="(sel, index) in selected"
              :key="index"
            >
              {{ sel.NAME }}
              <div
                class="selected-property"
                v-if="form.PROPERTY.group === 'management'"
              >
                {{ sel.TYPE }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12" v-else-if="form.PROPERTY.equipment">
          <b-btn
            block
            size="sm"
            rounded
            @click="openEquipments"
            variant="secondary"
            :disabled="!form.PROPERTY.equipment"
            >Adicionar ou remover Equipamentos ({{ selected.length }})
          </b-btn>

          <div class="selected-box">
            <div
              class="selected-item"
              v-for="(sel, index) in selected"
              :key="index"
            >
              {{ sel.NAME }}
              <div
                class="selected-property"
                v-if="form.PROPERTY.equipment == 'sensor'"
              >
                {{ sel.TYPE }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-xs-12"
          v-if="
            (form.PROPERTY.equipment && selected.length) ||
            form.PROPERTY.equipmentless
          "
        >
          <b-btn block ref="formSearchBtn" variant="3v3" @click="checkForm">
            Buscar dados
          </b-btn>
        </div>
      </div>

      <b-modal
        ref="formError"
        no-close-on-backdrop
        centered
        hide-header
        hide-footer
        size="sm"
        body-bg-variant="warning"
      >
        <h5>Atenção!</h5>
        <div class="row">
          <div class="col-xs-12">
            Não é possível realizar a busca de dados porque
          </div>
          <div class="col-xs-3 center-xs">
            <alert-icon title="" style="font-size: 3em" />
          </div>
          <ul class="col-xs-9">
            <li v-for="err in errors" :key="err">{{ err }}</li>
          </ul>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="light"
          size="sm"
          @click="$refs.formError.hide"
          >Vou corrigir</b-btn
        >
      </b-modal>

      <b-modal
        ref="formEquipments"
        centered
        hide-header
        hide-footer
        size="sm"
        @hidden="$refs.formSearchBtn.focus()"
      >
        <h6>Equipamentos ({{ selected.length }} selecionados)</h6>
        <div v-if="form.PROPERTY.equipment == 'actuator'">
          <b-btn
            size="sm"
            block
            class="col-xs-12"
            @click="$refs.actuatorFilter.show()"
          >
            Filtro: {{ actuatorFilterTitle }}
          </b-btn>

          <b-modal ref="actuatorFilter" centered hide-header hide-footer>
            <div class="equipment-table">
              <b-list-group>
                <b-list-group-item
                  button
                  @click="filterActuatorBy('all')"
                  :disabled="actuatorFilterTitle == 'Todos os atuadores'"
                >
                  Todos os atuadores
                </b-list-group-item>
                <b-list-group-item
                  button
                  @click="filterActuatorBy('pumps')"
                  :disabled="actuatorFilterTitle == 'Apenas bombas'"
                >
                  Apenas bombas
                </b-list-group-item>
                <b-list-group-item
                  button
                  @click="filterActuatorBy('actuators')"
                  :disabled="actuatorFilterTitle == 'Apenas válvulas'"
                >
                  Apenas válvulas
                </b-list-group-item>
                <b-list-group-item
                  button
                  disabled
                  v-if="actuatorFilters.length"
                >
                  Filtrar por bomba:
                </b-list-group-item>
                <b-list-group-item
                  button
                  id="pumps"
                  header="Filtros"
                  v-for="f in actuatorFilters"
                  :key="f"
                  @click="filterActuatorBy(f)"
                  :disabled="actuatorFilterTitle == f"
                >
                  {{ f }}
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-modal>
        </div>
        <div class="equipment-table">
          <div v-if="loadingLogOptions" class="col-xs-12 center-xs w-100 mt-2">
            <spinner />
            <span> Aguarde...</span>
          </div>
          <!-- <div v-if='!loadingLogOptions && retryEquipments' class='row center-xs btn-report'>
            <b-btn variant='primary' @click='loadEquipments'>TENTAR NOVAMENTE</b-btn>
          </div> -->
          <b-table
            v-if="!loadingLogOptions"
            striped
            small
            borderless
            hover
            responsive
            :items="eqps"
            :fields="fields"
          >
            <template slot="HEAD_CHECK">
              <b-form-checkbox
                @click.native.prevent="toggleAll()"
                v-model="allSelected"
              ></b-form-checkbox>
            </template>
            <template slot="CHECK" slot-scope="row">
              <b-form-checkbox
                :value="row.item"
                v-model="selected"
              ></b-form-checkbox>
            </template>
            <template slot="NAME" slot-scope="row">
              {{ row.item.NAME }}
              <span
                class="sensor-detail"
                v-if="form.PROPERTY.equipment == 'sensor'"
              >
                <br />
                {{ row.item.TYPE }} ({{ row.item.UNIT }})
              </span>
            </template>
          </b-table>
        </div>
        <b-btn
          v-show="$refs.formEquipments"
          block
          size="sm"
          @click="$refs.formEquipments.hide()"
          >Voltar</b-btn
        >
      </b-modal>

      <b-modal
        ref="formUsers"
        centered
        hide-header
        hide-footer
        size="sm"
        @hidden="$refs.formSearchBtn.focus()"
      >
        <h6>
          Usuários ({{ selected.length }}
          selecionados)
        </h6>
        <div class="users-table">
          <b-table
            striped
            small
            borderless
            hover
            responsive
            :items="users"
            :fields="fieldsUsersCheckbox"
          >
            <template slot="HEAD_CHECK">
              <b-form-checkbox
                @click.native.prevent="toggleAll()"
                v-model="allSelected"
              >
              </b-form-checkbox>
            </template>
            <template slot="CHECK" slot-scope="row">
              <b-form-checkbox
                :value="row.item"
                v-model="selected"
              ></b-form-checkbox>
            </template>
            <template slot="NAME" slot-scope="row">
              {{ row.item.NAME }}
            </template>
          </b-table>
        </div>
        <b-btn
          v-if="$refs.formUsers"
          block
          size="sm"
          @click="$refs.formUsers.hide()"
          >Voltar</b-btn
        >
      </b-modal>
      <footer id="footer">
        <b-btn size="sm" block @click="$emit('close-form')"> Fechar </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import PickEquipment from "@/common/components/PickEquipment";
import moment from "moment";
import reporstList from "../reportsList";
import { reports, users } from "@/api";
import { isMobile } from "@/pages/components/helpers.js";
import { managementSectorUseCases } from "../../../../api/modules/sector/useCases";
export default {
  name: "report-form",
  props: {
    showForm: Boolean,
    managementAccess: Boolean,
  },
  components: {
    PickEquipment,
  },
  mixins: [reporstList],
  data() {
    return {
      showImprovedReports: false,
      readSpaceOptions: [
        {
          text: "Hora",
          seconds: 60 * 60,
        },
        {
          text: "30 minutos",
          seconds: 30 * 60,
        },
        {
          text: "15 minutos",
          seconds: 15 * 60,
        },
        {
          text: "10 minutos",
          seconds: 10 * 60,
        },
        {
          text: "05 minutos",
          seconds: 5 * 60,
        },
      ],
      form: {
        readTime: null,
        PICKED_COLUMNS: [],
        PROPERTY: {},
        START_TIME: "00:00",
        START_DATE: moment().subtract(1, "days").format("YYYY-MM-DD"),
        END_DATE: moment().format("YYYY-MM-DD"),
        END_TIME: "00:00",
        INTERVAL: 0.083,
        ORGANIZATION: "raw",
      },
      radioVariant: {
        property: "outline-primary",
        interval: "outline-success",
      },
      disableGroup: {
        organization: true,
        interval: true,
      },
      disableInterval: {
        five: true,
      },
      disableOrganization: {
        raw: false,
        avg: false,
        occ: false,
      },
      tooltip: { title: "Desabilitado", placement: "bottom" },
      selected: [],
      loadingLogOptions: false,
      controller: null,
      eqps: [],
      users: [],
      allSelected: false,
      errors: [],
      actuatorFilterTitle: "Todos os atuadores",
      actuatorFilters: [],
    };
  },
  watch: {
    selected() {
      if (this.form.PROPERTY.group === "management") {
        this.allSelected =
          this.selected.length && this.selected.length == this.users.length
            ? true
            : false;
      } else {
        this.allSelected =
          this.selected.length && this.selected.length == this.eqps.length
            ? true
            : false;
      }
    },
    eqps() {
      this.allSelected =
        this.selected.length && this.selected.length == this.eqps.length
          ? true
          : false;
    },
    "form.INTERVAL": function (newValue, oldValue) {
      /* controle da tooltip de indisponibilidade de meios de organização e intervalo;
      e da disponibilidade de meios de organização e intervalos baseado no tipo de dado
      escolhido */
      if (newValue == 0.083 || this.form.PROPERTY.type == "volume") {
        this.disableGroup.organization = true;
        this.$root.$emit("bv::enable::tooltip", "report-organization-radio");
        this.form.ORGANIZATION = "raw";
      } else {
        this.disableGroup.organization = false;
        this.$root.$emit("bv::disable::tooltip", "report-organization-radio");
      }
    },
    "form.PROPERTY": async function (newValue, oldValue) {
      console.log({ newValue, oldValue });
      this.form.PICKED_COLUMNS = this.columnsToPickOptions.map(
        (col) => col.value,
      );

      if (newValue.group === "management") {
        this.users = [];
        this.selected = [];
        // Relatório diário: default hoje; usuário pode escolher um dia passado no datepicker.
        if (newValue.type === "daily") this.form.START_DATE = this.today;
        this.loadingLogOptions = true;
        await this.loadUsers();
      }
      const filteringByEquipments = Reflect.has(newValue, "equipment");

      if (filteringByEquipments && newValue.equipment != oldValue.equipment) {
        /* cancela requisições pendendes e troca as opções da tabela
        quando o tipo de equipamento muda */
        if (!!oldValue.equipment && this.requestOpen)
          this.cancelPendingRequestIfExists();
        this.eqps = [];
        this.users = [];
        this.selected = [];
        this.loadingLogOptions = true;

        this.loadEquipments();
      }
      /* controle na disponibilidade de meios de organização e intervalos
      baseados no tipo de dado escolhido */
      if (newValue.type == "volume") {
        this.disableGroup.organization = true;
        this.disableInterval.five = true;
        this.form.INTERVAL = 24;
        this.$root.$emit("bv::enable::tooltip", "report-organization-radio");
      } else {
        let notOcc = ["flow", "measure", "battery"]; // bruto e média
        let notAvg = ["modo", "open", "stat"]; // bruto e ocorrência
        if (
          notOcc.indexOf(oldValue.type) == -1 &&
          notOcc.indexOf(newValue.type) > -1
        ) {
          this.disableOrganization = {
            raw: false,
            avg: false,
            occ: true,
          };
        } else if (
          notAvg.indexOf(oldValue.type) == -1 &&
          notAvg.indexOf(newValue.type) > -1
        ) {
          this.disableOrganization = {
            raw: false,
            avg: true,
            occ: false,
          };
        }
        this.disableInterval.five = false;
        this.form.INTERVAL = 0.083;
      }
      /* controle da tooltip de indisponibilidade de meios de organização e intervalo */
      if (!oldValue.type && newValue.type) {
        this.$root.$emit("bv::disable::tooltip", "report-interval-radio");
        this.disableGroup.interval = false;
      }
    },
  },
  async created() {
    this.form.PROPERTY = this.reportsPropertiesOptions[0].options[0].value;

    await this.loadEquipments();

    users
      .getAddonsPermission()
      .then((r) => (this.showImprovedReports = !!(r && r.IMPROVED_REPORTS)));

    this.form.readTime = this.readSpaceOptions.find(
      (opt) => opt.seconds == 3600,
    ).seconds;
  },
  computed: {
    today() {
      return moment().format("YYYY-MM-DD");
    },
    columnsToPickOptions() {
      if (!this.form.PROPERTY.TO_PICK_COLUMNS) {
        return [];
      }

      return this.form.PROPERTY.TO_PICK_COLUMNS.map((col) => {
        return { text: col, value: col };
      });
    },
    isV5Report() {
      return (
        (this.form.PROPERTY.equipment === "sensor" &&
          this.form.PROPERTY.type !== "measure") ||
        this.form.PROPERTY.equipment === "hydrometer" ||
        this.form.PROPERTY.type == "daily" ||
        ["management", "station"].includes(this.form.PROPERTY.group) ||
        (this.form.PROPERTY.IS_DAILY === true &&
          this.form.PROPERTY.equipment === "actuator")
      );
    },
    showOptionsReadType() {
      return this.form.PROPERTY.group === "station";
    },
    fields() {
      return [
        {
          key: "CHECK",
        },
        {
          label: this.eqps.length + " opções",
          key: "NAME",
        },
      ];
    },
    fieldsUsersCheckbox() {
      return [
        {
          key: "CHECK",
        },
        {
          label: this.users.length + " opções",
          key: "NAME",
        },
      ];
    },
  },
  methods: {
    setSelected(selected) {
      this.selected = selected;
    },
    isMobile(ref) {
      return isMobile(ref);
    },
    resetForm() {
      this.item = {
        PROPERTY: {
          type: null,
          equipment: null,
        },
        ORGANIZATION: "raw",
        INTERVAL: 0.083,
        START_DATE: "",
        START_TIME: "",
        END_DATE: "",
        END_TIME: "",
      };
      this.disableGroup.interval = true;
      this.disableGroup.organization = true;
      // this.retryEquipments = false;
      this.eqps = [];
      this.users = [];
      this.selected = [];
      this.allSelected = false;
    },
    checkForm() {
      if (this.showOptionsReadType && !this.form.readTime) {
        this.errors.push("É necessário especificar o formato de leitura");
      }

      if (this.isV5Report) {
        // Sem usuários selecionados, tratamos como "todos": manejo busca o histórico
        // de todos os editores carregados em vez de travar a busca.
        this.$emit("make-report", {
          start: this.form.START_DATE,
          end: this.form.END_DATE,
          ...this.form.PROPERTY,
          readTime: this.form.readTime,
          PICKED_COLUMNS: this.form.PICKED_COLUMNS,
          START_TIME: this.form.START_TIME,
          END_TIME: this.form.END_TIME,
          elements: this.selected.length ? this.selected : this.users,
        });

        return;
      }

      this.errors = [];
      let start = `${this.form.START_DATE} ${this.form.START_TIME}`;
      let end = `${this.form.END_DATE} ${this.form.END_TIME}`;
      if (!this.form.START_DATE) this.errors.push("Data inicial vazio");
      if (!this.form.START_TIME) this.errors.push("Hora inicial vazio");
      if (!this.form.END_DATE) this.errors.push("Data final vazio");
      if (!this.form.END_TIME) this.errors.push("Hora final vazio");
      if (start.trim() && end.trim()) {
        if (start > end)
          this.errors.push(
            "Data-hora inicial não pode ser posterior à data-hora final",
          );
        else if (start == end)
          this.errors.push(
            "Data-hora inicial não pode ser igual à data-hora final",
          );
      }
      if (this.errors.length) this.$refs.formError.show();
      else {
        const data = {
          start,
          end,
          elements: this.selected,
          equipment: this.form.PROPERTY.equipment,
          type: this.form.PROPERTY.type,
          group: this.form.PROPERTY.group,
          organization: this.form.ORGANIZATION,
          interval: this.form.INTERVAL,
          readTime: this.form.readTime,
        };

        this.$emit("make-report", data);
      }
    },
    openEquipments() {
      this.$refs.formEquipments.show();
    },
    openUsers() {
      this.$refs.formUsers.show();
    },
    cancelPendingRequestIfExists() {
      this.controller.abort();
    },
    filterActuatorBy(str) {
      if (this.form.PROPERTY.equipment == "actuator") {
        if (str == "all") {
          this.eqps = this.eqpsReq.map((e) => e);
          this.actuatorFilterTitle = "Todos os atuadores";
        } else if (str == "pumps") {
          this.eqps = this.eqpsReq.filter((e) => e.ID < 1000000);
          this.actuatorFilterTitle = "Apenas bombas";
        } else if (str == "actuators") {
          this.eqps = this.eqpsReq.filter((e) => e.ID > 1000000);
          this.actuatorFilterTitle = "Apenas válvulas";
        } else {
          this.eqps = this.eqpsReq.filter((e) => e.PUMP_NAME == str);
          this.actuatorFilterTitle = str;
        }
        this.$refs.actuatorFilter.hide();
      }
    },
    toggleAll() {
      this.allSelected = !this.allSelected;
      if (this.form.PROPERTY.group) {
        if (this.selected.length < this.users.length) {
          this.selected = this.users.slice();
        } else if (this.selected.length == this.users.length) {
          this.selected = [];
        }
      } else {
        if (this.selected.length < this.eqps.length) {
          this.selected = this.eqps.slice();
        } else if (this.selected.length == this.eqps.length) {
          this.selected = [];
        }
      }
    },
    loadEquipments() {
      this.controller = new AbortController();
      if (this.form.PROPERTY.equipment == "device") this.loadDirs();
      else if (this.form.PROPERTY.equipment == "sensor") this.loadSensors();
      else if (this.form.PROPERTY.equipment == "actuator") this.loadActuators();
      else if (this.form.PROPERTY.equipment == "hydrometer")
        this.loadHidrometers();
      else if (this.form.PROPERTY.equipment == null)
        this.loadingLogOptions = false;
    },
    async loadUsers() {
      this.requestOpen = true;
      const users = await managementSectorUseCases().getAllEditors.execute();
      this.users = users;

      this.requestOpen = false;
      this.loadingLogOptions = false;
    },
    loadActuators() {
      this.requestOpen = true;
      reports
        .getActuators(this.controller)
        .then((ret) => {
          this.eqps = ret.length ? ret.filter((e) => !!e.NAME) : [];
          this.eqpsReq = ret.length ? ret.filter((e) => !!e.NAME) : [];
          this.actuatorFilters = ret.length
            ? ret.map((e) => e.PUMP_NAME).filter((e) => !!e)
            : [];
          if (this.actuatorFilters.length)
            this.actuatorFilters = this.actuatorFilters.filter(
              (e, i, arr) => arr.indexOf(e) == i,
            );
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro ao buscar atuadores.");
          // this.retryEquipments = true;
          return;
        })
        .then((_) => {
          this.requestOpen = false;
          this.loadingLogOptions = false;
        })
        .catch((e) => {
          return;
        });
    },
    loadDirs() {
      this.requestOpen = true;
      reports
        .getDirs(this.controller)
        .then((ret) => {
          this.eqps = ret.length ? ret.filter((e) => !!e.NAME) : [];
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro ao buscar dirs.");
          // this.retryEquipments = true;
          return;
        })
        .then((_) => {
          this.requestOpen = false;
          this.loadingLogOptions = false;
        })
        .catch((e) => {
          return;
        });
    },
    loadSensors() {
      this.requestOpen = true;
      reports
        .getSensors(this.controller)
        .then((ret) => {
          this.eqps = ret.length ? ret.filter((e) => !!e.NAME) : [];
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro ao buscar sensores.");
          // this.retryEquipments = true;
          return;
        })
        .then((_) => {
          this.requestOpen = false;
          this.loadingLogOptions = false;
        })
        .catch((e) => {
          return;
        });
    },
    loadHidrometers() {
      this.requestOpen = true;
      reports
        .getHidrometers(this.controller)
        .then((ret) => {
          this.eqps = ret.length ? ret.filter((e) => !!e.NAME) : [];
          console.log(this.eqps);
        })
        .catch((err) => {
          console.error(err);
          alert("Ocorreu um erro ao buscar sensores.");
          return;
        })
        .then((_) => {
          this.requestOpen = false;
          this.loadingLogOptions = false;
        })
        .catch((e) => {
          return;
        });
    },
  },
};
</script>

<style scoped>
.equipment-table {
  height: 310px !important;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
